import { render, staticRenderFns } from "./failed.vue?vue&type=template&id=20574800&scoped=true&"
import script from "./failed.vue?vue&type=script&lang=js&"
export * from "./failed.vue?vue&type=script&lang=js&"
import style0 from "./failed.vue?vue&type=style&index=0&id=20574800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20574800",
  null
  
)

export default component.exports